import React from "react";
import _authService from 'modules/AuthService';
import { Drawer } from "antd";


class PublicFooter extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isDrawerOpen: false,
        drawerContent: "",
        drawerHeading: "",
      };
    }

    onClose = () => {
      this.setState({
        visible: false,
      });
    };
  
    showDrawer = async (contentKey) => {
      
      this.setState({
        visible: true,
      });  

      if(contentKey === "aboutus"){
        this.setState({ drawerHeading: "About Us" });
      }else if(contentKey === "privacypolicy"){
        this.setState({ drawerHeading: "Privacy Policy" });
      }else if(contentKey === "termsandconditions"){
        this.setState({ drawerHeading: "Terms & Conditions" });
      }else if(contentKey === "refundpolicies"){
        this.setState({ drawerHeading: "Cancellation/Refund Policies" });
      }else if(contentKey === "contactus"){
        this.setState({ drawerHeading: "Contact Us" });
      }


      try {
        const response = await _authService.getPortalConfigurationByKey(contentKey);
        
        if (response.status === 200 && response.data) { 
          this.setState({ drawerContent: response.data.Value });
          
        } else {
          this.setState({ drawerContent: "Content not available" });
        }
      } catch (error) {
        console.error("API Error:", error);
        
      }
    };
  


    render() {

      // Phase C.6.2.1 (Candidate Homepage Branding, Content Source & Visual Hardening): the Product
      // Owner clarified the 5 link buttons below must not appear inside (or duplicated alongside) the
      // homepage's new "Important Links" card. `hideLinkBar` lets the homepage suppress just this
      // inline button row while keeping everything else (the compatibility statement, the Drawer and
      // its showDrawer()/getPortalConfigurationByKey() fetch — the "existing mechanism" the governing
      // document requires be reused, not duplicated) completely unchanged. Every other consumer of
      // this component (ForgotPassword_new, Registration_new, ResetPassword, SetPassword, PrivateLayout)
      // omits the prop and renders exactly as before — this is additive, not a behavior change for them.
      // Phase C.7.4A (§10/§21 footer root-cause fix): `className` is new, optional, and additive —
      // every existing consumer (LandingPage_new_one via its own homepage-only `.candidate.ent-home`
      // ancestor selector, ForgotPassword_new, ResetPassword, SetPassword, PrivateLayout) omits it and
      // renders byte-identical output. Registration_new.jsx is the first consumer to pass one, because
      // <PublicFooter/> there is a sibling of `.registrationForm` in the DOM (not a descendant), so no
      // existing descendant-selector CSS could ever target it from that page alone.
      const { hideLinkBar, className } = this.props;
      return (
        <>
          <div className={`footer-loginPage p-4 loginFooterText${className ? ` ${className}` : ''}`}>
            <div className="text-center text-info">
              <div className="mt-3">

                <div className="footer-disclaimer-text">
                  <strong>
                    Support and Best Viewed on Microsoft Edge: Web Browsers Version 125+, Mozilla Firefox: Web Browsers Version 113+, Google Chrome: Web Browsers Version 113+
                  </strong>
                  {!hideLinkBar && (
                  // Phase C.7.2 (Candidate Experience Shell, §14 footer foundation): replaced the
                  // <br/><br/> + literal &nbsp;/&nbsp;&nbsp; spacing between these 5 buttons with a
                  // real flex/gap row (.ent-footer-link-row below) — same 5 buttons, same
                  // showDrawer()/getPortalConfigurationByKey() mechanism, same labels, only the
                  // spacing technique changed, so wrapping is now even and viewport-responsive
                  // instead of depending on non-breaking-space runs.
                  <div className="ent-footer-link-row">
                    <button type="button" className="footer-link-button" onClick={() => this.showDrawer("refundpolicies")}>
                      Cancellation/Refund Policies
                    </button>
                    <button type="button" className="footer-link-button" onClick={() => this.showDrawer("contactus")}>Contact Us</button>
                    <button type="button" className="footer-link-button" onClick={() => this.showDrawer("aboutus")}>About Us</button>
                    <button type="button" className="footer-link-button" onClick={() => this.showDrawer("privacypolicy")}>Privacy Policy</button>
                    <button type="button" className="footer-link-button" onClick={() => this.showDrawer("termsandconditions")}>
                      Terms &amp; Conditions
                    </button>
                  </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <Drawer
          title={<h4 className="drawer-heading">{this.state.drawerHeading}</h4>}
          placement="right"
          closable={true}
          onClose={this.onClose}
          visible={this.state.visible}
          width={"90%"}
          style={{ transition: "transform 0.7s ease-in-out" }}
          rootClassName="custom-motion-drawer"
          motion={{
            motionName: "fade-slide-in",
            motionAppear: true,
            motionLeave: true,
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: this.state.drawerContent }}></div>
          
        </Drawer>
   

        </>
      );
    }
  }
  
  export default PublicFooter;